import React from "react";

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /// Required: a switch has no visible text of its own.
  "aria-label": string;
  disabled?: boolean;
}

/// An on/off setting that applies the moment it flips, with no Save beside it.
/// A choice that only lands on submit is a checkbox.
export const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  "aria-label": ariaLabel,
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    disabled={disabled}
    className="switch"
    onClick={() => onChange(!checked)}
  />
);
